export default function ({ route, redirect }) {
    if (process.client) {
        window.scrollTo(0, 0);
    }
}